import { getDoctorIdentityIds } from "./liveControls";

function normalizeName(value) {
  const name = String(value || "").trim();
  return name || null;
}

function getFullName(value) {
  const fullName = normalizeName(value?.fullName || value?.displayName || value?.name);
  if (fullName) return fullName;

  const firstName = normalizeName(value?.firstName);
  const lastName = normalizeName(value?.lastName);
  return [firstName, lastName].filter(Boolean).join(" ") || null;
}

export function getLiveCommentAuthorName(comment, currentDoctor) {
  const author = comment?.author || comment?.user || comment?.doctor || {};
  const name =
    getFullName(author) ||
    normalizeName(comment?.authorName) ||
    normalizeName(comment?.doctorName);
  if (name) return name;

  const commentDoctorId = String(comment?.doctorId || "").trim();
  if (commentDoctorId && getDoctorIdentityIds(currentDoctor).includes(commentDoctorId)) {
    return getFullName(currentDoctor);
  }

  return "Médecin";
}